import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import "./style.css";
import { languages } from "../../../../constants/jsonConstant";
import { images } from "../../../../constants";
import LocationModal from "../../../../components/locationmodal/LocationModal";
import { Card } from "react-bootstrap";
import ClearIcon from "@mui/icons-material/Clear";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { FailedNotify } from "../../../../constants/tostify";
import axios from "axios";
import SearchIcon from "@mui/icons-material/Search";
import { getAsset } from "../../../../helpers/helper";
import { Controller } from "react-hook-form";
import { getErrorMessage } from "../../../../hooks/promotionValidation";

const Promotionleftside = ({
  promoteShop,
  setPromoteShop,
  control,
  errors = {},
}) => {
  const [mshow, setMshow] = useState(false);
  const [checktype, setChecktype] = useState("");
  const [createService, setCreateService] = useState({
    images: [],
    portfolioImages: [],
    videos: [],
  });

  const onDrop = async (acceptedFiles) => {
    try {
      const abc = await publishImage(acceptedFiles);
      setCreateService((createService) => ({
        ...createService,
        images: abc,
      }));
      setPromoteShop({
        ...promoteShop,
        media: [...promoteShop.media, ...abc],
      });

      setUploadedImages((prev) => [...prev, ...abc]);
    } catch (error) {
      FailedNotify(getErrorMessage(error, "Failed to upload image. Please try again."));
    }
  };

  const onDropport = async (acceptedFiles) => {
    try {
      const abc = await publishImage(acceptedFiles);
      setCreateService((createService) => ({
        ...createService,
        portfolioImages: abc,
      }));
      setPromoteShop({
        ...promoteShop,
        media: abc,
      });
      setUploadedImages((prev) => [...prev, ...abc]);
    } catch (error) {
      FailedNotify(getErrorMessage(error, "Failed to upload image. Please try again."));
    }
  };

  const onDropvideo = async (acceptedFiles) => {
    try {
      const abc = await publishImage(acceptedFiles);
      setPromoteShop({
        ...promoteShop,
        media: abc,
      });
      setCreateService((createService) => ({
        ...createService,
        videos: abc,
      }));
      setUploadedImages((prev) => [...prev, ...abc]);
    } catch (error) {
      FailedNotify(getErrorMessage(error, "Failed to upload video. Please try again."));
    }
  };

  const { getRootProps: getRootPropsImage, getInputProps: getInputPropsImage } =
    useDropzone({
      accept: "image/*",
      onDrop,
    });

  const { getRootProps: getRootPropsPort, getInputProps: getInputPropsPort } =
    useDropzone({
      accept: "image/*",
      onDrop: onDropport,
    });

  const { getRootProps: getRootPropsVideo, getInputProps: getInputPropsVideo } =
    useDropzone({
      accept: "video/*",
      onDrop: onDropvideo,
    });

  const [uploadedImages, setUploadedImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");

  const removeImage = (index) => {
    const updatedImages = [...uploadedImages];
    updatedImages.splice(index, 1);

    setUploadedImages(updatedImages);

    setPromoteShop({
      ...promoteShop,
      media: updatedImages,
    });
  };

  const handleClose = () => setMshow(false);
  const handleShow = () => setMshow(true);

  const [selectedCountry, setSelectedCountry] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedstateone, setSelectedstateone] = useState("");
  const [searchTermone, setSearchTermone] = useState("");
  const [selectedcity, setSelectedcity] = useState("");
  const [searchTermtwo, setSearchTermtwo] = useState("");
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  //Function to handle the country selection
  const handleCountryChange = (event) => {
    const { value } = event.target;
    setSelectedCountry(value);
  };
  //
  const handleSearchChangestate = (event) => {
    setSearchTermone(event.target.value);
  };

  const handleSearchChangecity = (event) => {
    setSearchTermtwo(event.target.value);
  };

  // Function to handle the state selection
  const handleCountryChangestate = (event) => {
    const { value } = event.target;
    setSelectedstateone(value);
  };

  // Function to handle the city selection
  const handleCountryChangecity = (event) => {
    const { value } = event.target;
    setSelectedcity(value);
  };
  const [hidefield, setHidefield] = useState(1);
  const [hidestate, setHidestate] = useState(1);
  const [hidecity, setHidecity] = useState(1);
  const [countrydata, SetCountrydata] = useState([]);
  const [getcountry] = useState();
  const [selectedState] = useState();
  const [getState, setState] = useState([]);
  const [getcity, setGetcity] = useState([]);
  const [statetwo, setStatetwo] = useState(getcountry);
  const [city, setCity] = useState(selectedState);
  const [open, setOpen] = useState(getcountry);
  const [selectedSegment, setSelectedSegment] = useState("custom");
  const handleSegmentChange = (value) => {
    setSelectedSegment(value);
  };
  useEffect(() => {
    axios
      .get(
        "https://pkgstore.datahub.io/core/world-cities/world-cities_json/data/5b3dd46ad10990bca47b04b4739a02ba/world-cities_json.json"
      )
      .then((res) => SetCountrydata(res.data))

      .catch((error) => {});
  }, []);
  const country = [...new Set(countrydata.map((item) => item.country))];
  country.sort();
  const handleCountry = (e) => {
    let states = countrydata.filter(
      (state) => state.country === e.target.value
    );
    states = [...new Set(states.map((item) => item.subcountry))];
    states.sort();
    setState(states);
  };
  const handleState = (e) => {
    let cities = countrydata.filter(
      (city) => city.subcountry === e.target.value
    );
    setGetcity(cities);
  };

  return (
    <div>
      <LocationModal mshow={mshow} handleClose={handleClose} />
      <Container>
        <div className="ps-3">
          <div className="pt-3 col-10">
            <h6 className="">Select Type</h6>

            <Form.Select
              className="border_3 promote-inputs-style"
              aria-label="Default select example"
              onChange={(e) => {
                setChecktype(e.target.value);
                setPromoteShop({
                  ...promoteShop,
                  type: e.target.value === "1" ? "banner" :
                    e.target.value === "2" ? "video" : "carousel",
                });
              }}
            >
              <option disabled selected>
                Select Type
              </option>

              <option value="1">Banner</option>
              <option value="2">Video</option>
              <option value="3">Carousel</option>
            </Form.Select> 
          </div>

          <h5 className="heading-top mt-2">Upload Image or Video</h5>

          {checktype && checktype === "1" ? (
            <Col md={4} lg={3} xl={2} xs={4}>
              <Card
                style={{ width: "6rem", height: "6rem" }}
                {...getRootPropsPort()}
                className="cursor_P"
              >
                <Card.Img className="imet-fit" src={images.AddImage} />
                <Card.Body>
                  <input
                    type="file"
                    id="fileInputPort"
                    style={{ display: "none" }}
                    name="portfolioImages"
                    {...getInputPropsPort()}
                    multiple
                  />
                </Card.Body>
              </Card>
            </Col>
          ) : checktype && checktype === "2" ? (
            <Col md={4} lg={3} xl={2} xs={4}>
              <Card
                style={{ width: "6rem", height: "6rem" }}
                {...getRootPropsVideo()}
                className="cursor_P"
              >
                <Card.Img className="imet-fit" src={images.Addvideo} />
                <Card.Body>
                  <input
                    type="file"
                    id="fileInputVideo"
                    style={{ display: "none" }}
                    name="videos"
                    {...getInputPropsVideo()}
                  />
                </Card.Body>
              </Card>
            </Col>
          ) : checktype && checktype === "3" ? (
            <Col md={4} lg={3} xl={2} xs={4}>
              <Card
                style={{ width: "6rem", height: "6rem" }}
                {...getRootPropsImage()}
                className="cursor_P"
              >
                <Card.Img className="imet-fit" src={images.AddImage2} />
                <Card.Body>
                  <input
                    type="file"
                    id="fileInputImage"
                    style={{ display: "none" }}
                    name="images"
                    {...getInputPropsImage()}
                  />
                </Card.Body>
              </Card>
            </Col>
          ) : (
            ""
          )}

          {/* <------------Remove-Image-----------> */}
          <Col lg={4} className=" mt-2 d-flex justify-content-start gap-2 ">
            {uploadedImages.map((image, index) => (
              <Card
                style={{
                  width: "6rem",
                  height: "6rem",
                  border: "2px solid",
                }}
                key={index}
              >
                <Card.Img
                  className="imet-fit upload-img"
                  src={getAsset(image)}
                  crossOrigin="anonymous"
                  alt={`Uploaded ${index}`}
                />
                <div
                  className="close-btnone"
                  onClick={() => removeImage(index)}
                >
                  <ClearIcon />
                </div>
              </Card>
            ))}
          </Col>

          {/* <------------Remove-Image-----------> */}

          <Col lg="10" xl="10" className="mt-3 des-placeholder">
            <h6 className="mb-2">Description</h6>
            {control ? (
              <Controller
                name="description"
                control={control}
                render={({ field }) => (
                  <textarea
                    className={`promote-inputs-style w-100 ${
                      errors?.description ? "border-danger" : ""
                    }`}
                    value={field.value || ""}
                    onChange={(e) => {
                      field.onChange(e);
                      setPromoteShop({
                        ...promoteShop,
                        description: e.target.value,
                      });
                    }}
                    onBlur={field.onBlur}
                    rows={4}
                    maxLength={500}
                    placeholder="Write at least 20 characters describing your ad..."
                  />
                )}
              />
            ) : (
              <textarea
                className="promote-inputs-style w-100"
                value={promoteShop.description}
                onChange={(e) =>
                  setPromoteShop({
                    ...promoteShop,
                    description: e.target.value,
                  })
                }
                rows={4}
                maxLength={500}
                placeholder="Write at least 20 characters describing your ad..."
              />
            )}
            <div className="d-flex justify-content-between align-items-start mt-1">
              {errors?.description ? (
                <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                  {errors.description.message}
                </p>
              ) : (
                <span />
              )}
              <span className="text-muted" style={{ fontSize: "11px" }}>
                {(promoteShop.description || "").trim().length}/500
              </span>
            </div>
          </Col>

          <div className="pt-2">
            <h5 className="heading-top">Enter detail of targeted audience</h5>
          </div>
          <h6 className="pt-2">Audience Location</h6>

          <div className="col-md-10 ">
            <label
              htmlFor="inputPassword4"
              placeholder="First name"
              className="form-label labelSize"
            >
              Country*
            </label>
            <div className="blood-type custom-fix-one p-2">
              {/* <div className="d-flex">
                <div className="w-100">
                  <input
                    type="search"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    placeholder="Search country here...."
                    className="w-100 search-input"
                    onClick={() => setHidefield(0)}
                  />
                </div>
                <div>
                  <span>
                    <SearchIcon className="search-icon-fs" />
                  </span>
                </div>
              </div> */}

              <select
                onClick={() => setHidefield(1)}
                value={selectedCountry}
                name="country"
                onChange={(e) => {
                  handleCountryChange(e);
                  handleCountry(e);

                  setPromoteShop({
                    ...promoteShop,
                    location: {
                      ...promoteShop.location,
                      country: e.target.value,
                    },
                  });
                }}
                className="b-radius selectSize w-100 "
              >
                {hidefield && <option value="">Select country</option>}

                {country
                  .filter((country) =>
                    country.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .map((country, index) => (
                    <option key={country} value={country}>
                      {country}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="col-md-10">
            <label
              htmlFor="inputPassword4"
              placeholder="First name"
              className="form-label labelSize"
            >
              State*
            </label>
            <div className="blood-type custom-fix-one p-2">
              {/* <div className="d-flex">
                <div className="w-100">
                  <input
                    type="search"
                    value={searchTermone}
                    onChange={handleSearchChangestate}
                    placeholder="Search state here...."
                    className="w-100 search-input"
                    onClick={() => setHidestate(0)}
                  />
                </div>
                <div>
                  <span>
                    <SearchIcon className="search-icon-fs" />
                  </span>
                </div>
              </div> */}

              <select
                onClick={() => setHidestate(1)}
                className="b-radius selectSize w-100 "
                value={selectedstateone}
                aria-label="Default select example "
                name="state"
                onChange={(e) => {
                  handleState(e);
                  handleCountryChangestate(e);

                  setPromoteShop({
                    ...promoteShop,
                    location: {
                      ...promoteShop.location,
                      state: e.target.value,
                    },
                  });
                }}
              >
                {hidestate && <option value="">Select state</option>}

                {getState
                  .filter((country) =>
                    country.toLowerCase().includes(searchTermone.toLowerCase())
                  )
                  .map((country) => (
                    <option key={country} value={country}>
                      {country}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="col-md-10">
            <label
              htmlFor="inputPassword4"
              placeholder="First name"
              className="form-label labelSize"
            >
              City
            </label>
            <div className="blood-type custom-fix-one p-2">
              {/* <div className="d-flex">
                <div className="w-100">
                  <input
                    type="search"
                    value={searchTermtwo}
                    onChange={handleSearchChangecity}
                    placeholder="Search city here...."
                    className="w-100 search-input"
                    onClick={() => setHidecity(0)}
                  />
                </div>
                <div>
                  <span>
                    <SearchIcon className="search-icon-fs" />
                  </span>
                </div>
              </div> */}
              <select
                onClick={() => setHidecity(1)}
                value={selectedcity}
                className=" selectSize w-100 "
                aria-label="Default select example"
                name="city"
                onChange={(e) => {
                  handleCountryChangecity(e);

                  setPromoteShop({
                    ...promoteShop,
                    location: {
                      ...promoteShop.location,
                      city: e.target.value,
                    },
                  });
                }}
              >
                {hidecity && <option value="">Select city</option>}

                {getcity
                  .filter((country) =>
                    country.name
                      .toLowerCase()
                      .includes(searchTermtwo.toLowerCase())
                  )
                  .map((country) => (
                    <option key={country.name}>{country.name}</option>
                  ))}
              </select>
            </div>
          </div>

          {/* <Form.Select
            className="border_3 "
            style={{ width: "55%" }}
            aria-label="Default select example"
          >
            <option>location</option>
          </Form.Select> */}
          <div className="pt-4">
            <h6 className="heading-two">
              Age <span className="text-muted fw-normal" style={{ fontSize: "12px" }}>(optional)</span>
            </h6>
            <p className="text-muted mb-2" style={{ fontSize: "12px" }}>
              Leave empty to show this ad to all ages.
            </p>
          </div>
          <div className="d-flex flex-column w-50">
            <input
              type="number"
              className="border_3 promote-inputs-style p-1"
              placeholder="Min Age"
              min={1}
              max={120}
              value={promoteShop.ageMin ?? ""}
              onChange={(e) =>
                setPromoteShop({
                  ...promoteShop,
                  ageMin: e.target.value,
                })
              }
            />

            <input
              type="number"
              placeholder="Max Age"
              className="border_3 promote-inputs-style mt-2 p-1"
              min={1}
              max={120}
              value={promoteShop.ageMax ?? ""}
              onChange={(e) =>
                setPromoteShop({
                  ...promoteShop,
                  ageMax: e.target.value,
                })
              }
            />
          </div>
          <h6 className="pt-3">
            Gender <span className="text-muted fw-normal" style={{ fontSize: "12px" }}>(optional)</span>
          </h6>
          <p className="text-muted mb-2" style={{ fontSize: "12px" }}>
            Choose &quot;All&quot; to show this ad to every gender.
          </p>
          <div>
            <Form>
              {["radio"].map((type) => (
                <div key={`inline-${type}`} className="mb-3">
                  <Form.Check
                    type="radio"
                    name="ad-gender"
                    label="All"
                    checked={promoteShop.gender === "all" || !promoteShop.gender}
                    onChange={() =>
                      setPromoteShop({ ...promoteShop, gender: "all" })
                    }
                  />

                  <Form.Check
                    type="radio"
                    name="ad-gender"
                    label="Men"
                    checked={promoteShop.gender === "male"}
                    onChange={() =>
                      setPromoteShop({ ...promoteShop, gender: "male" })
                    }
                  />

                  <Form.Check
                    type="radio"
                    name="ad-gender"
                    label="Women"
                    checked={promoteShop.gender === "female"}
                    onChange={() =>
                      setPromoteShop({ ...promoteShop, gender: "female" })
                    }
                  />
                </div>
              ))}
            </Form>
          </div>

          <div className="col-10">
            <h6 className="pt-1">Language </h6>

            <Form.Select
              onChange={(e) =>
                setPromoteShop({
                  ...promoteShop,
                  language: e.target.value,
                })
              }
              className="border_3  promote-inputs-style"
              aria-label="Default select example"
            >
              <option selected disabled>Select Language</option>
              {languages?.map((e) => (
                
                <option>{e.lang}</option>
              ))}
            </Form.Select>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Promotionleftside;
